export enum EAppointmentCfgKeys {
  StopResetAfterMonth = 'AppointmentCfg:StopResetAfterMonth'
}

export enum ECloudRxConfigKeys {
  IsEnabled = 'CloudRx:IsEnabled'
}

export enum EPharmaciergeConfigKeys {
  IsEnabled = 'Pharmacierge:IsEnabled'
}

export enum ESignatureRxConfigKeys {
  IsEnabled = 'SIGNATURERX:ENABLED'
}

export enum ENationWideConfigKeys {
  IsEnabled = 'Pathology:Nationwide:IsEnabled',
  ClientCode = 'Pathology:Nationwide:ClientCode',
  Markup = 'Pathology:Nationwide:Markup'
}

export enum ETheDoctorsLaboratoryConfigKeys {
  IsEnabled = 'Pathology:TDL:IsEnabled',
  ClientCode = 'Pathology:TDL:ClientCode',
  // Mutually-exclusive selector for how the TDL client / source code is set.
  // Values: 'Clinic' (single clinic-wide ClientCode) or 'Practitioner'
  // (per-practitioner codes on tblTheDoctorsLaboratoryUser).
  ClientCodeMode = 'Pathology:TDL:ClientCodeMode',
  Markup = 'Pathology:TDL:Markup'
}

export enum ETheDoctorsLaboratoryClientCodeMode {
  Clinic = 'Clinic',
  Practitioner = 'Practitioner'
}

export enum EHeidiConfigKeys {
  IsEnabled = 'Heidi:IsEnabled'
}

export enum ETranscriptionConfigKeys {
  AllowanceMinutes = 'Transcription:AllowanceMinutes',
  /** 'mock' selects the in-browser mock provider (local testing without SLNG). */
  Provider = 'Transcription:Provider'
}

export enum EInteleradConfigKeys {
  IsEnabled = 'Intelerad:IsEnabled',
  AppointmentCompletionMode = 'Intelerad:AppointmentCompletionMode',
  PostProcessingTemplateId = 'Intelerad:PostProcessingTemplateId'
}

export enum EMedicalImagingConfigKeys {
  ManualProcedureCodesIsEnabled = 'MI:ManualProcCodes'
}

export enum ECemplicityConfigKeys {
  IsEnabled = 'CEMPLICITY:ENABLED'
}

export enum EEmailConfigKeys {
  SelectFromEnabled = 'Email:SelectFrom:Enabled'
}

export enum EConfigKeys {
  ACCOUNTING_LOCK_DATE = 'ACCOUNTING LOCK DATE',
  ADDRESS1AUTOCOMPLETEVALUE = 'ADDRESS1AUTOCOMPLETEVALUE',
  ADDRESS2AUTOCOMPLETEVALUE = 'ADDRESS2AUTOCOMPLETEVALUE',
  ADDRESS3AUTOCOMPLETEVALUE = 'ADDRESS3AUTOCOMPLETEVALUE',
  ADDRESS4AUTOCOMPLETEVALUE = 'ADDRESS4AUTOCOMPLETEVALUE',
  ADDRESS5AUTOCOMPLETEVALUE = 'ADDRESS5AUTOCOMPLETEVALUE',
  AddressControlDefaultCountry = 'AddressControlDefaultCountry',
  AdvancedDiaryEvents = 'AdvancedDiaryEvents',
  ALLOWCENTRALUSERSTOPICKLOCATION = 'ALLOWCENTRALUSERSTOPICKLOCATION',
  ALLOWHIGHERROLENOTEACCESS = 'ALLOWHIGHERROLENOTEACCESS',
  ALLOWLINKEDCASES = 'ALLOWLINKEDCASES',
  AUTHCODESFORAPPTS = 'AUTHCODESFORAPPTS',
  AUTHCODES_EDITFROMCASES = 'AUTHCODES_EDITFROMCASES',
  AUTOCOMPLETEADDRESSES = 'AUTOCOMPLETEADDRESSES',
  AUTOCLOSE_CASE = 'AUTOCLOSE_CASE',
  AUTOCLOSE_CONSULTATION = 'AUTOCLOSE_CONSULTATION',
  AUTOLOGOUTINTERVAL = 'AUTOLOGOUTINTERVAL',
  AUTOMATICCONFIRMATIONS = 'AUTOMATICCONFIRMATIONS',
  AUTOMATICCONFIRMATIONSOPTION = 'AUTOMATICCONFIRMATIONSOPTION',
  AUTO_SCROLL_SCORES_GOALS = 'AUTO_SCROLL_SCORES_GOALS',
  BILL_FOR_APPOINTMENTS = 'BILL FOR APPOINTMENTS',
  BILLCANCELLATIONASAPPT = 'BILLCANCELLATIONASAPPT',
  BODYSPECIFICDIAGCODES = 'BODYSPECIFICDIAGCODES',
  CANCELLATIONDAYS = 'CANCELLATIONDAYS',
  CANCELLATION_FEE = 'CANCELLATION FEE',
  CANCELLATION_LEDGER_CODE = 'CANCELLATION LEDGER CODE',
  CHOOSE_FIRST_CONSULTATION_TYPE = 'CHOOSE_FIRST_CONSULTATION_TYPE',
  CLEAR_ACCEPT_AVAILABLE = 'CLEAR_ACCEPT_AVAILABLE',
  HAS_CLEARACCEPT_SETUP = 'HAS_CLEARACCEPT_SETUP',
  HAS_STRIPE_SETUP = 'HAS_STRIPE_SETUP',
  CURRENCYSYMBOL = 'CURRENCYSYMBOL',
  DEFAULT_TASK_ASSIGNEE = 'DEFAULT_TASK_ASSIGNEE',
  DEFAULT_TASK_ASSIGNEE_TEAM_ID = 'DEFAULT_TASK_ASSIGNEE_TEAM_ID',
  C_AMBERFLAG_NAME = 'C_AMBERFLAG NAME',
  C_BLACKFLAG_NAME = 'C_BLACKFLAG NAME',
  C_BLUEFLAG_NAME = 'C_BLUEFLAG NAME',
  C_REDFLAG_NAME = 'C_REDFLAG NAME',
  C_YELLOWFLAG_NAME = 'C_YELLOWFLAG NAME',
  DIARYPRICEDISPLAY = 'DIARYPRICEDISPLAY',
  DIARYALLOWCROSSLOCDRAGDROP = 'DIARYALLOWCROSSLOCDRAGDROP',
  DIARYREFRESHRATE = 'DIARYREFRESHRATE',
  DID_NOT_ATTEND_FEE = 'DID NOT ATTEND FEE',
  DISCOUNT_LEDGER_CODE = 'DISCOUNT LEDGER CODE',
  DNA_LEDGER_CODE = 'DNA LEDGER CODE',
  DONEXTENABLED = 'DONEXTENABLED',
  DOMAINS_AUTHENTICATED = 'DOMAINS_AUTHENTICATED',
  DUPLICATECONFIRMATIONEMAILTOLOCATION = 'DUPLICATECONFIRMATIONEMAILTOLOCATION',
  EMAIL_APPOINTMENTREMINDER_TM3 = 'EMAIL_APPOINTMENTREMINDER_TM3',
  EMAIL_BOOKINGCONFIRM_TM3 = 'EMAIL_BOOKINGCONFIRM_TM3',
  EMAIL_CANCELCONFIRM_TM3 = 'EMAIL_CANCELCONFIRM_TM3',
  EMAIL_CANCELNOTIFY_TM3 = 'EMAIL_CANCELNOTIFY_TM3',
  EMAIL_CLASSREMINDER_TM3 = 'EMAIL_CLASSREMINDER_TM3',
  EMAIL_GROUPNOTIFY_TM3 = 'EMAIL_GROUPNOTIFY_TM3',
  EMAIL_INVOICE_TM3 = 'EMAIL_INVOICE_TM3',
  EMAIL_RECEIPT_TM3 = 'EMAIL_RECEIPT_TM3',
  ENABLESMSBYDEFAULT = 'ENABLESMSBYDEFAULT',
  FILTERMODE = 'FILTERMODE',
  FIRSTDAYOFWEEK = 'FIRSTDAYOFWEEK',
  FORCECONSULTATIONAPPOINTMENTLINK = 'FORCECONSULTATIONAPPOINTMENTLINK',
  INCOMEDEFAULTLOCATION = 'INCOMEDEFAULTLOCATION',
  INVOICE_DUE = 'INVOICE DUE',
  LETTER_DISCHARGE_TM3 = 'LETTER_DISCHARGE_TM3',
  LINKAPPTSTOCASE = 'LINKAPPTSTOCASE',
  LOCATION = 'LOCATION',
  MAKEDOBREQUIRED = 'MAKEDOBREQUIRED',
  MAKEADDRESSREQUIRED = 'MAKEADDRESSREQUIRED',
  MANDITORYCANCELLATIONREASON = 'MANDITORYCANCELLATIONREASON',
  MANDITORYREFUNDREASON = 'MANDITORYREFUNDREASON',
  MEDIPASS_ENABLED = 'MEDIPASS_ENABLED',
  OSICSCODES = 'OSICSCODES',
  PATALTREF = 'PATALTREF',
  PATREFMANDATORY = 'PATREFMANDATORY',
  PATREFREADONLY = 'PATREFREADONLY',
  REMOTE_SUPPORT_URL = 'REMOTE_SUPPORT_URL',
  REMOTE_SUPPORT_URL_AUS = 'REMOTE_SUPPORT_URL_AUS',
  REQUIREPRACTITIONERTOBELINKED = 'REQUIREPRACTITIONERTOBELINKED',
  S_REMINDERS_SENDEMAIL = 'S_REMINDERS_SENDEMAIL',
  S_REMINDERS_SENDSMS = 'S_REMINDERS_SENDSMS',
  S_REMINDERS_REMINDERTIME = 'S_REMINDERS_REMINDERTIME',
  S_REMINDERS_DAYSFROMNOW = 'S_REMINDERS_DAYSFROMNOW',
  S_REMINDERS_EMAILNOTIFICATION = 'S_REMINDERS_EMAILNOTIFICATION',
  S_REMINDERS_SMSNOTIFICATION = 'S_REMINDERS_SMSNOTIFICATION',
  SESSIONSONLINEBYDEFAULT = 'SESSIONSONLINEBYDEFAULT',
  SHOWCASESWITHINCOMPLETENOTES = 'SHOWCASESWITHINCOMPLETENOTES',
  SHOWDIARYTODAYLINE = 'SHOWDIARYTODAYLINE',
  SHOWEXTRAADDRESSLINE = 'SHOWEXTRAADDRESSLINE',
  SHOWPATALTREFONDIARY = 'SHOWPATALTREFONDIARY',
  SHOWPATREFONDIARY = 'SHOWPATREFONDIARY',
  SHOWREFWITHNAME = 'SHOWREFWITHNAME',
  SMS_APPOINTMENTREMINDER_TM3 = 'SMS_APPOINTMENTREMINDER_TM3',
  SMS_BOOKINGCONFIRM_TM3 = 'SMS_BOOKINGCONFIRM_TM3',
  SMS_CANCELCONFIRM_TM3 = 'SMS_CANCELCONFIRM_TM3',
  SMS_CANCELNOTIFY_TM3 = 'SMS_CANCELNOTIFY_TM3',
  SMS_CLASSREMINDER_TM3 = 'SMS_CLASSREMINDER_TM3',
  ENABLE_MULTIPLE_CHARGES_OPTION = 'ENABLE_MULTIPLE_CHARGES_OPTION',
  ADDITIONAL_ITEMS_AFTER_APPOINTMENT_DURATION = 'ADDITIONAL_ITEMS_AFTER_APPOINTMENT_DURATION',
  ENABLE_COMMISSION_ATTRIBUTION = 'ENABLE_COMMISSION_ATTRIBUTION',
  TM3MODE = 'TM3MODE',
  TRANSFER_LEDGER_CODE = 'TRANSFER LEDGER CODE',
  TRANSFER_TEXT = 'TRANSFER TEXT',
  VAT_NO = 'VAT NO',
  VAT_RATE = 'VAT RATE',
  VAT_REGISTERED = 'VAT REGISTERED',
  WORKINGWEEKDAYS = 'WORKINGWEEKDAYS',
  ENFORCE_DIARY_WORKING_TIME_RESTRICTIONS = 'ENFORCE_DIARY_WORKING_TIME_RESTRICTIONS',
  ENFORCE_DIARY_BOOKING_STOCK_RESTRICTIONS = 'ENFORCE_DIARY_BOOKING_STOCK_RESTRICTIONS',
  ENFORCE_DIARY_SKILL_RESTRICTIONS = 'ENFORCE_DIARY_SKILL_RESTRICTIONS',
  WRITEOFF_LEDGER_CODE = 'WRITEOFF LEDGER CODE',
  PASSWORD_EXPIRY_FREQUENCY = 'PASSWORD_EXPIRY_FREQUENCY',
  PASSWORD_EXPIRY = 'PASSWORD_EXPIRY',
  DIAG_LIST = 'DIAG LIST',
  MAKEROOMMANDATORY = 'MAKEROOMMANDATORY',
  COPYCASEMODDATA = 'COPYCASEMODDATA',
  COPYCASEASSDATA = 'COPYCASEASSDATA',
  COPYCASECONSULTDATA = 'COPYCASECONSULTDATA',
  OZ_MODE = 'OZ MODE',
  PATIENT_LOCATION_SECURITY = 'PATIENT LOCATION SECURITY',
  WORKFLOW_BUFFER_1 = 'WORKFLOW_BUFFER_1',
  WORKFLOW_BUFFER_2 = 'WORKFLOW_BUFFER_2',
  WORKFLOW_BUFFER_3 = 'WORKFLOW_BUFFER_3',
  MANUAL_WORKFLOW_CREATION_NAVIGATE = 'MANUAL_WORKFLOW_CREATION_NAVIGATE',
  ALLOWALLPRACTWEEKVIEW = 'ALLOWALLPRACTWEEKVIEW',
  MAILCHIMP_API_KEY = 'MAILCHIMP_API_KEY',
  MAILCHIMP_USERNAME = 'MAILCHIMP_USERNAME',
  MAILCHIMP_LIST_ID = 'MAILCHIMP_LIST_ID',
  ENABLED_MAILCHIMP_INTEGRATION = 'ENABLED_MAILCHIMP_INTEGRATION',
  HEADER_IMAGE = 'HEADER_IMAGE',
  FOOTER_IMAGE = 'FOOTER_IMAGE',
  HEADER_HEIGHT = 'HEADER_HEIGHT',
  FOOTER_HEIGHT = 'FOOTER_HEIGHT',
  SQUARE_AUTHENTICATED = 'SQUARE_AUTHENTICATED',
  SQUARE_AVAILABLE = 'SQUARE_AVAILABLE',
  SQUARE_HAS_TERMINALS_PAIRED = 'SQUARE_HAS_TERMINALS_PAIRED',
  TM3_PAYMENTS_DEVICE = 'TM3_PAYMENTS_DEVICE',
  TM3_PAYMENTS_MERCHANT = 'TM3_PAYMENTS_MERCHANT',
  TM3_PAYMENTS_SERVICE_PORT = 'TM3_PAYMENTS_SERVICE_PORT',
  TM3_PAYMENTS_ENABLE_TM3 = 'TM3_PAYMENTS_ENABLE_TM3',
  TM3_PAYMENTS_ENABLE_ONLINE = 'TM3_PAYMENTS_ENABLE_ONLINE',
  TM3_PAYMENTS_ENABLE_PAYBYTEXT = 'TM3_PAYMENTS_ENABLE_PAYBYTEXT',
  TM3_PAYMENTS_ENABLE_BULK_MODE = 'TM3_PAYMENTS_ENABLE_BULK_MODE',
  TM3_PAYMENTS_ENABLE_STRIPE_INTEGRATION = 'TM3_PAYMENTS_ENABLE_STRIPE_INTEGRATION',
  TM3_PAYMENTS_ALLOW_CHASE = 'TM3_PAYMENTS_ALLOW_CHASE',
  TM3_PAYMENTS_ALLOW_AUTOPAY = 'TM3_PAYMENTS_ALLOW_AUTOPAY',
  TM3_PAYMENTS_STRIPE_API_KEY = 'TM3_PAYMENTS_STRIPE_API_KEY',
  TM3_PAYMENTS_STRIPE_API_SECRET = 'TM3_PAYMENTS_STRIPE_API_SECRET',
  TM3_PAYMENTS_CHASE_AUTOPAY_FAILURES = 'TM3_PAYMENTS_CHASE_AUTOPAY_FAILURES',
  TM3_HEALTHCODE_ENABLED = 'TM3_HEALTHCODE_ENABLED',
  CASEFLOW_PREREFERRAL_INFORMATION_ENABLED = 'CASEFLOW_PREREFERRAL_INFORMATION_ENABLED',
  CASEFLOW_REFERRAL_PORTAL_ENABLED = 'CASEFLOW_REFERRAL_PORTAL_ENABLED',
  CASEFLOW_PATIENT_PORTAL_ENABLED = 'CASEFLOW_PATIENT_PORTAL_ENABLED',
  CASEFLOW_EDITABLE_PRICING_ENABLED = 'CASEFLOW_EDITABLE_PRICING_ENABLED',
  PATIENT_MATCH_RESTRICT_TO_GROUP = 'PATIENT_MATCH_RESTRICT_TO_GROUP',
  DIARY_WORKFLOW_SELECTION_REQUIRED = 'DIARY_WORKFLOW_SELECTION_REQUIRED',
  TwoFactorAuthRequired = 'TWO_FACTOR_AUTH_REQUIRED',
  TwoFactorAuthEnabled = 'TWO_FACTOR_AUTH_ENABLED',
  TwoFactorAuthEnabledForConnect = 'TWO_FACTOR_AUTH_ENABLED_FOR_CONNECT',
  SignatureRxEnabled = 'SIGNATURERX:ENABLED',
  ALLOW_WAITING_LIST_PAYMENTS = 'ALLOW_WAITING_LIST_PAYMENTS',
  SHOW_DEFAULT_CHARGES = 'SHOW_DEFAULT_CHARGES',
  SPLIT_BY_FIRST_FOLLOW_UP = 'SPLIT_BY_FIRST_FOLLOW_UP',
  AppointmentCfgStopResetAfterMonth = EAppointmentCfgKeys.StopResetAfterMonth,
  APPLE_PAY_ENABLED = 'APPLE_PAY_ENABLED',
  DIARY_HAS_OPENING_HOURS_VIEW = 'DIARY_HAS_OPENING_HOURS_VIEW',
  HIDE_MFA_OPTIONS = 'HIDE_MFA_OPTIONS',
  ENABLE_BILLING_FROM_CASE = 'ENABLE_BILLING_FROM_CASE',
  CRM_INTEGRATION_PIPEDRIVE_ENABLED = 'CRM_INTEGRATION_PIPEDRIVE_ENABLED',
  CRM_INTEGRATION_PIPEDRIVE_CONTACTS_SYNC_MODE = 'CRM_INTEGRATION_PIPEDRIVE_CONTACTS_SYNC_MODE',
  CRM_INTEGRATION_PIPEDRIVE_STOCK_SYNC_MODE = 'CRM_INTEGRATION_PIPEDRIVE_STOCK_SYNC_MODE',
  CRM_INTEGRATION_PIPEDRIVE_CONTACTS_TAG = 'CRM_INTEGRATION_PIPEDRIVE_CONTACTS_TAG',
  CRM_INTEGRATION_PIPEDRIVE_STOCK_TAG = 'CRM_INTEGRATION_PIPEDRIVE_STOCK_TAG',
  CRM_INTEGRATION_HUBSPOT_ENABLED = 'CRM_INTEGRATION_HUBSPOT_ENABLED',
  CRM_INTEGRATION_HUBSPOT_CONTACTS_SYNC_MODE = 'CRM_INTEGRATION_HUBSPOT_CONTACTS_SYNC_MODE',
  CRM_INTEGRATION_HUBSPOT_STOCK_SYNC_MODE = 'CRM_INTEGRATION_HUBSPOT_STOCK_SYNC_MODE',
  CRM_INTEGRATION_HUBSPOT_CONTACTS_TAG = 'CRM_INTEGRATION_HUBSPOT_CONTACTS_TAG',
  CRM_INTEGRATION_HUBSPOT_STOCK_TAG = 'CRM_INTEGRATION_HUBSPOT_STOCK_TAG',
  CRM_INTEGRATION_SALESFORCE_ENABLED = 'CRM_INTEGRATION_SALESFORCE_ENABLED',
  CRM_INTEGRATION_SALESFORCE_CONTACTS_SYNC_MODE = 'CRM_INTEGRATION_SALESFORCE_CONTACTS_SYNC_MODE',
  CRM_INTEGRATION_SALESFORCE_STOCK_SYNC_MODE = 'CRM_INTEGRATION_SALESFORCE_STOCK_SYNC_MODE',
  CRM_INTEGRATION_SALESFORCE_CONTACTS_TAG = 'CRM_INTEGRATION_SALESFORCE_CONTACTS_TAG',
  CRM_INTEGRATION_SALESFORCE_STOCK_TAG = 'CRM_INTEGRATION_SALESFORCE_STOCK_TAG',
  SHOW_ADDITIONAL_APPOINTMENT_STATUS = 'SHOW_ADDITIONAL_APPOINTMENT_STATUS',
  DIARY_DAY_NOTES_ENABLED = 'DIARY_DAY_NOTES_ENABLED',
  FF_HEALTHCODE_LOOKUP = 'FF_HEALTHCODE_LOOKUP'
}

export type TFlagsConfigKeys =
  | EConfigKeys.C_REDFLAG_NAME
  | EConfigKeys.C_AMBERFLAG_NAME
  | EConfigKeys.C_YELLOWFLAG_NAME
  | EConfigKeys.C_BLUEFLAG_NAME
  | EConfigKeys.C_BLACKFLAG_NAME;

export default EConfigKeys;
